export default __webpack_public_path__ + "static/media/img8.c5bfa1d4.png";